import { render, staticRenderFns } from "./scoreboard-section.vue?vue&type=template&id=da1a6d5e&scoped=true&"
import script from "./scoreboard-section.vue?vue&type=script&lang=ts&"
export * from "./scoreboard-section.vue?vue&type=script&lang=ts&"
import style0 from "./scoreboard-section.vue?vue&type=style&index=0&id=da1a6d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1a6d5e",
  null
  
)

export default component.exports